export default __webpack_public_path__ + "static/media/prev-Marine-Receiver-1.b9437a50.png";